<template>
  <b-input-group 
    size="sm"
  > 
    <b-form-input
      v-model.number="value[field]" 
      :placeholder="(placeholder || 0).toString()"
      type="number"
      step="0.005"
      min="0"
      @input="(input) => $emit('input', input === '' ? { ...value, [field]: null } : { ...value, [field]: Number(input) })"
    />
  </b-input-group>
</template>
<script>
    export default {
        name: 'IndexBedrag',
        components: {
        },
        props: {
            value: {
                type: Object,
                default: () => null,
            },
            placeholder: {
                type: Number,
                default: () => null,
            },
            field: {
                type: String,
                default: () => null,
            },
        },
        data() {
            return  {
                
            }
        },
        computed: {
            fieldExists() {
                return this.value && this.value[this.field] !== null;
            },
        },
        watch: {},
        mounted() {
        },
        methods: {
            clearField() {
                this.$set(this.value,this.field,null);
            }
        }
    }
</script>